<template>
  <div class="section">
    <div class="container">
      <div class="content">
        <!-- title -->
        <div v-if="!isEmpty">
          <div class="menu-label is-size-6">
            <span class="fa fa-file-text"></span>
            <span>CONTRACT</span>
            <span class="has-text-info" @click="isShowingQR = !isShowingQR">
              <i class="fa fa-qrcode"></i>
            </span>
          </div>
          <!-- qr code -->
          <b-collapse :open.sync="isShowingQR">
            <div class="content">
              <QRCode :value="qrAddress"
                  :options="{ size: 160 }"></QRCode>
            </div>
          </b-collapse>
        </div>

        <code class="is-size-5 has-text-weight-bold">
          {{ $route.params.hash }}
        </code>

        <!-- timeline -->
        <div v-if="contract.name" class="timeline">
          <header class="timeline-header">
            <span class="tag is-medium is-primary">{{ contract.name }}</span>
          </header>
          <!-- timeline body -->
          <div class="timeline-item is-primary" v-for="(event, key) in contract.events" :key="key">

            <div class="timeline-marker is-icon" :class="{'is-primary': !event.pending, 'is-warning': event.pending}">
              <!-- little icon for different event types -->
              <i v-if="event.event_name==='OwnershipTransferred'" class="fa fa-exchange"></i>
              <i v-else-if="event.event_name==='VendorDeployed'" class="fa fa-plus"></i>
              <i v-else-if="event.event_name==='ProductDeployed'" class="fa fa-cubes"></i>
              <i v-else-if="event.event_name==='OperatorAdded'" class="fa fa-user-plus"></i>
              <i v-else-if="event.event_name==='OperatorRemoved'" class="fa fa-user-times"></i>
              <i v-else-if="event.event_name==='ProducerAdded'" class="fa fa-truck"></i>
              <i v-else-if="event.event_name==='ProducerRemoved'" class="fa fa-bomb"></i>
              <i v-else-if="event.event_name==='ProductItemAdded'" class="fa fa-cube"></i>
              <i v-else-if="event.event_name==='OperationAdded'" class="fa fa-wrench"></i>
            </div>
            <div class="timeline-content">
              <p class="heading">
                <a v-bind:href="'#/tx/' + event.transaction">
                  {{ event.event_name }}
                </a>
              </p>
              <!-- event types -->
              <div v-if="event.event_name==='OwnershipTransferred'">
                <div>
                  <p class="is-size-7" v-if="parseInt(event.output) !== 0">Previous Owner <br>
                    <a v-if="parseInt(event.output) !== 0" v-bind:href="'#/contract/' + event.output" class="is-size-7">
                      <code class="has-text-info">{{ event.output }}</code>
                    </a>
                  </p>
                  <p class="is-size-7">New Owner <br>
                    <a v-bind:href="'#/contract/' + event.input" class="is-size-7">
                      <code class="has-text-info">{{ event.input }}</code>
                    </a>
                  </p>
                </div>
              </div>
              <div v-else-if="event.event_name==='VendorDeployed'">
                <p class="heading">{{$utils.formatTimestamp(event.input.timestamp)}}</p>
                <p>
                  <a v-bind:href="'#/contract/' + event.input.owner">{{ event.input.name }}</a>
                </p>
                <p>{{ event.input.desc }}</p>
              </div>
              <div v-else-if="event.event_name==='ProductDeployed'">
                <p class="heading">{{$utils.formatTimestamp(event.input.timestamp)}}</p>
                <p>
                  <a v-bind:href="'#/contract/' + event.output">{{ event.input.name }}</a>
                </p>
                <p>{{ event.input.desc }}</p>
                <barcode
                  :value="event.input.barcode"
                  height="60"
                  lineColor="#363636">Invalid Barcode
                </barcode>
                <figure class="image is-96x96">
                  <img :src="event.input.image">
                </figure>
              </div>
              <div v-else-if="event.event_name==='OperatorAdded' || event.event_name==='ProducerAdded' || event.event_name==='OperatorRemoved' || event.event_name==='ProducerRemoved'">
                <p>
                  <a v-bind:href="'#/contract/' + event.output">Account</a>
                </p>
              </div>
              <div v-else-if="event.event_name==='ProductItemAdded'">
                <p class="heading">{{$utils.formatTimestamp(event.input.timestamp)}}</p>
                <p>{{ event.input.number }} ProductItem added.</p>
              </div>
              <div v-else-if="event.event_name==='OperartionAdded'">
                <p class="heading">{{$utils.formatTimestamp(event.input.timestamp)}}</p>
                <p>{{ event.input.type }}</p>
                <p>{{ event.input.desc }}</p>
                <figure class="image is-96x96">
                  <img :src="event.input.image">
                </figure>
                <p>Index: {{event.output }}</p>
              </div>
            </div>

          </div>
          <header class="timeline-header">
            <span class="tag is-medium is-primary">{{ contract.name }}</span>
          </header>
          <!-- timeline body -->
        </div>
        <!-- json -->
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from '@xkeshi/vue-qrcode'
  import VueBarCode from 'vue-barcode'
  import { mapState } from 'vuex'

  export default {
    name: 'Contract',
    components: {
      'QRCode': QRCode,
      'barcode': VueBarCode
    },
    mounted () {
      this.$store.dispatch('loadContract', this.$route.params.hash.toLowerCase())
    },
    data () {
      return {
        isShowingQR: false
      }
    },
    computed: {
      ...mapState(['contract']),
      isEmpty () {
        return this.contract.name === undefined
      },
      qrAddress () {
        return window.location.protocol + '//' + window.location.host + '/#/tx/' + this.$route.params.hash
      }
    }
  }
</script>

<style lang="scss" scoped>
  .timeline {
    padding-top: 2rem;
  }

  code {
    word-wrap: none!important;
  }

  figure {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Contract.vue